import { Stack } from 'expo-router';

export default function VideoCallLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: 'fade',
        gestureEnabled: false,
      }}
    />
  );
}
